<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-dialog
        v-model="dialog"
        scrollable  
        persistent
        max-width="750px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Client Information for {{viewedItem.name}} </span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedItem.email"
                    readonly
                    hide-details
                    label="Email"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedItem.location" 
                    readonly
                    hide-details
                    label="Location"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedItem.telephone" 
                    readonly
                    hide-details
                    label="Telephone"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field 
                    v-model="viewedItem.topics" 
                    readonly
                    hide-details
                    label="Topics"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea 
                    auto-grow
                    rows="1"
                    v-model="viewedItem.bio" 
                    readonly
                    hide-details
                    label="Background"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title class="title">
            Client Admin
            </v-toolbar-title>
          </v-toolbar>
          
          <v-card-title>
            Client Search
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="clients"
            :search="search"
            :loading="clientsLoading"
          >
            <template slot="item" slot-scope="props">
              <tr>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.location }}</td>
              <td class="text-xs-center">
                <v-icon
                  v-if="props.item.authorised"
                  color="primary"
                >
                  check
                </v-icon>
                <v-icon
                  v-else
                  color="secondary"
                >
                  close
                </v-icon>
              </td>
              <td class="justify-center layout px-0">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    slot="activator"
                    class="mr-2 mt-2"
                    @click="viewItem(props.item)"
                  >
                    visibility
                  </v-icon>
                  </template>
                  <span>View client details</span>  
                </v-tooltip>
                <v-tooltip right v-if="props.item.authorised == false">
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    slot="activator"
                    class="mr-2 mt-2"
                    color="green"
                    @click="changeUserAuth(props.item)"
                  >
                    check_circle
                  </v-icon>
                  </template>
                  <span>Authorise Client</span>  
                </v-tooltip>
                <v-tooltip right v-else>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    slot="activator"
                    class="mr-2 mt-2"
                    color="red"
                    @click="changeUserAuth(props.item)"
                  >
                    highlight_off
                  </v-icon>
                  </template>
                  <span>Disable Client</span>  
                </v-tooltip>
                <v-tooltip right v-if="props.item.authorised == true">
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    slot="activator"
                    class="mr-2 mt-2"
                    color="green"
                    @click="changeUserType(props.item)"
                  >
                    supervised_user_circle
                  </v-icon>
                  </template>
                  <span>Convert Client to Mentor</span>  
                </v-tooltip>
                
              </td>
              </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </v-card>

      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      search: '',
      dialog: false,
      headers: [
        { text: 'Client', value: 'name'},
        { text: 'Location', value: 'location'},
        { text: 'Authorised', value: 'authorised',align: 'center'}
      ],
      viewedIndex: -1,
      viewedItem: {},
      defaultItem: {}
    }),
    created: function() {
      // update the array of client user documents in the store
      this.$store.dispatch("updateClients")
    },
    computed: {
      clients: function() {
        // get all of the clients in the store
        return this.$store.getters.getAllClients
      },
      myProfile: function() {
        // get the current users profile from the store
        return this.$store.getters.getMyProfile
      },
      configData: function () {
        // get the configuration data from the store
        return this.$store.getters.getConfig
      },
      clientsLoading: function () {
        // get the flag to show the loading animation on the data table
        return this.$store.getters.getClientLoading
      }
    },
    methods: {
      viewItem (item) {
        // set the selected item into the viewed item object
        // then display the dialog box
        console.log("clientAdmin - selected item: ",item)
        this.viewedIndex = this.clients.indexOf(item)
        this.viewedItem = Object.assign({}, item)
        this.dialog = true
      },
      close () {
        // close the dialog box and clear the viewed item object
        this.dialog = false
        setTimeout(() => {
          this.viewedItem = Object.assign({}, this.defaultItem)
          this.viewedIndex = -1
        }, 300)
      },
      changeUserAuth (item) {
        // change the selected user's authorisation flag
        // using the 'saveAuthChange' action in the store
        console.log("clientAdmin - selected item: ",item)
        var authUpdate = {}
        authUpdate.email = item.email
        authUpdate.authorised = !item.authorised
        authUpdate.uid = item.id
        console.log("clientAdmin - update item: ",authUpdate)

        this.$store.dispatch("saveAuthChange",authUpdate)
      },
      changeUserType (item) {
        // change the selected user into a mentor
        // using the 'saveAuthChange' action in the store
        console.log("clientAdmin - selected item: ",item)
        var authUpdate = {}
        authUpdate.email = item.email
        authUpdate.mentor = true
        console.log("clientAdmin - update item: ",authUpdate)

        this.$store.dispatch("saveAuthChange",authUpdate)
      }
    }
  }
</script>

<style>

</style>
